import React from 'react'
import { Token } from '@components/Tokens/TokenSelector/tokenSchemas'
import { TokenSelectionDisplay } from '@components/Tokens/TokenSelector/TokenSelection'
import { Box, Stack } from '@ui'
import { ButtonSpinner } from 'ui/components/Spinner/ButtonSpinner'
import { VList } from 'ui/components/VList2/VList'
import { Address } from 'use-towns-client'

import { useBaseNftsForTransfer } from './useBaseNftsForTransfer'

export function NftsList({ walletAddress }: { walletAddress: Address | undefined }) {
    const { nfts, isFetching } = useBaseNftsForTransfer({ walletAddress })

    if (isFetching) {
        return (
            <Box centerContent grow paddingY="x4" height="100%">
                <ButtonSpinner />
            </Box>
        )
    }

    return (
        <Stack height="100%" position="relative">
            <VList
                getItemKey={(item) => item.data.address}
                align="top"
                list={nfts}
                estimateHeight={() => 75}
                itemRenderer={(data) => <VListItem token={data} />}
            />
        </Stack>
    )
}

function VListItem({ token }: { token: Token }) {
    return (
        <Stack paddingBottom="md">
            <TokenSelectionDisplay token={token} />
        </Stack>
    )
}
